import {type ReactElement, useMemo} from 'react'

import {AssigneeQuickFilter, AuthorQuickFilter} from './ActorQuickFilters'
import {LabelQuickFilter, MilestoneQuickFilter, ProjectQuickFilter} from './MetadataQuickFilters'
import type {QuickFilterProps} from './quick-filter-shared'
import {ReviewQuickFilter} from './ReviewQuickFilter'

export function useRepoPullsQuickFilterItems({
  owner,
  query,
  repo,
  onQueryChange,
  showLabels,
  showMilestones,
  showProjects,
}: QuickFilterProps & {
  showLabels: boolean
  showMilestones: boolean
  showProjects: boolean
}): ReactElement[] {
  return useMemo(
    () => [
      <AuthorQuickFilter key="authors" {...{owner, query, repo, onQueryChange}} />,
      ...(showLabels ? [<LabelQuickFilter key="labels" {...{owner, query, repo, onQueryChange}} />] : []),
      ...(showProjects ? [<ProjectQuickFilter key="projects" {...{owner, query, repo, onQueryChange}} />] : []),
      ...(showMilestones ? [<MilestoneQuickFilter key="milestones" {...{owner, query, repo, onQueryChange}} />] : []),
      <ReviewQuickFilter key="reviews" {...{owner, query, repo, onQueryChange}} />,
      <AssigneeQuickFilter key="assignees" {...{owner, query, repo, onQueryChange}} />,
    ],
    [onQueryChange, owner, query, repo, showLabels, showMilestones, showProjects],
  )
}
